<template>
  <label
    class="custom-checkbox"
    @click="$emit('click', $event)"
    :class="classes">
    <input
      @change="$emit('change', $event)"
      :name="name"
      :type="type"
      :checked="checked">
    <span class="custom-checkbox_checkmark"></span>
    <span
      class="custom-checkbox_label">
      <slot></slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'CustomCheckbox',
  props: {
    name: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    is_radio: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    bordered_radio: {
      type: Boolean,
      default: false
    },
    is_white: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    type() {
      return this.is_radio ? 'radio' : 'checkbox'
    },
    classes() {
      return {
        checkbox_radio: this.is_radio,
        bordered: this.bordered,
        bordered_radio: this.bordered_radio,
        is_white: this.is_white,
      }
    }
  }
}
</script>
